import React from "react";
import { Dropdown } from "./Dropdown";

/**
 * Preset point-in-time dates to be shown in the datepicker.
 */
export type DatePreset = {
  key: string;
  label: string;

  /**
   * This date will never be floored/ adjusted, even if you configure the
   * date picker to be day-only.
   */
  date: Date;
};

type DatePickerPresetsDropdownProps = {
  value: Date | undefined;
  title?: string;
  presets: DatePreset[];
  onSelect: (date: Date) => void;
};

export function DatePickerPresetsDropdown({
  value,
  title,
  presets,
  onSelect,
}: DatePickerPresetsDropdownProps) {
  const selectedPresetKey =
    value !== undefined ?
      presets.find((preset) => value.getTime() === preset.date.getTime())?.key
    : undefined;

  const options = presets.map((preset) => ({
    value: preset.key,
    label: preset.label,
  }));

  return (
    <Dropdown
      placeholder={title}
      value={selectedPresetKey}
      variant="outline"
      ariaLabel={title}
      options={options}
      onChange={(presetKey) => {
        const preset = presets.find((item) => item.key === presetKey);
        if (preset) {
          onSelect(preset.date);
        }
      }}
    />
  );
}
